import React from 'react';

const Disclosure = () => (
    <span className="disclosure">
        We may earn a commission when you use one of our links to make a purchase.
    </span>
);
export default Disclosure;